module.exports = __webpack_public_path__ + "img/3.40707d52.jpg";